export default __webpack_public_path__ + "static/media/background_image_yearn_watch_dark.edf27fe9.jpeg";